/** Element API routes that require JSON (not urlencoded) when no file is attached. */
export function isElementApiRoute(itemType) {
  return itemType === 'elements' || itemType === '/elements/delete';
}

/** True when backend returned a successful element lifecycle payload. */
export function isSuccessfulElementResponse(data) {
  if (!data || typeof data !== 'object') return false;
  if (data.ok === false) return false;
  if (typeof data.key !== 'string' || !data.key) return false;
  return data.created === true || data.edited === true || data.deleted === true;
}

export function isSuccessfulHttpResponse(response) {
  const status = response?.status ?? 0;
  return status >= 200 && status < 300;
}

/** Strip HTML and check for meaningful text content. */
export function hasMeaningfulRichText(html) {
  if (!html || typeof html !== 'string') return false;
  const stripped = html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\u00A0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return stripped.length > 0;
}

/** Default grid cell size when inserting a new content element in edit mode. */
export function defaultLayoutDimensionsForElement(element) {
  const type = element?.type || '';
  if (type === 'separator') return { w: 12, h: 2 };
  if (type === 'text' || type === 'cta3') return { w: 6, h: 6 };
  if (type === 'cta' || type === 'cta2') return { w: 6, h: 6 };
  if (type === 'image' || type === 'video') return { w: 6, h: 6 };
  if (type === 'iframe') return { w: 6, h: 6 };
  return { w: 6, h: 4 };
}
